import AnimSection from "../AnimSection/AnimSection";
import "./Benefits.css";
import { NAV_LINKS } from "../../utils/constants";

export default function BenefitsTemplate({ benefits, beforeAfter }) {
  return (
    <section id={NAV_LINKS[2].id} className="benefits">
      <div className="section">
        <div className="benefits__grid">

          <AnimSection>
            <span className="section-label">De ce să lucrezi cu noi</span>
            <h2 className="section-title">
              Nu agenție. Un programator<br />care înțelege afaceri.
            </h2>
            <p className="benefits__desc">
              Cu ani de experiență în development, construim soluții solide — nu scripturi
              fragile care se strică la prima schimbare.
            </p>
            <ul className="benefits__list">
              {benefits.map((benefit) => (
                <li key={benefit} className="benefits__list-item">
                  <span className="benefits__check">✓</span>
                  {benefit}
                </li>
              ))}
            </ul>
          </AnimSection>

          <AnimSection delay={200}>
            <div className="before-after">
              <div className="before-after__header">
                <div className="before-after__label before-after__label--before">Înainte</div>
                <div className="before-after__label before-after__label--after">După</div>
              </div>
              {beforeAfter.map(([before, after], i) => (
                <div key={i} className="before-after__row">
                  <div className="before-after__cell before-after__cell--before">✗ {before}</div>
                  <div className="before-after__cell before-after__cell--after">✓ {after}</div>
                </div>
              ))}
            </div>
          </AnimSection>

        </div>
      </div>
    </section>
  );
}
